import { useEffect, useState } from 'react';
import { debounce } from '@/utilities/debounce';

export const useSearch = (minDebounceLength = 3, initialValue?: string) => {
  const [search, setSearch] = useState(initialValue ?? '');
  const [debouncedSearch, setDebouncedSearch] = useState(initialValue ?? '');

  useEffect(() => {
    if (!search.length) {
      debounce(() => setDebouncedSearch(search), 500);
    }
    if (search?.length >= minDebounceLength) {
      debounce(() => setDebouncedSearch(search), 500);
    }
  }, [search]);

  return {
    search,
    setSearch,
    debouncedSearch,
  };
};
